(function ($) {
  $(function () {


    // AOS
    AOS.init();

    $('.nav-button').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.navigation-floating').toggleClass('opened');
      $('.overlay-black').addClass('active');

    });

    $('.nav-button.active').on('click', function () { 
      $(this).removeClass('active');
      $('.navigation-floating.opened').removeClass('opened');
    });

    /*
     * Navbar fixed 
     */
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 1) {
        $('.site-header').addClass('navbar-fixed-top');
      } else {
        $('.site-header').removeClass('navbar-fixed-top');
      }
    });

    /*
     * Toggle burger menu on mobile
     */
    $('.menu-btn-burger').on('click', function () {
      $('#nav-icon').toggleClass('open-custom-menu');
      $(".mobile-menu").toggleClass('sliding-open');
    });

    /* 
     * Owl carousel
     */
    $('.owl-room-card').owlCarousel({
      margin: 40,
      items: 3,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4500,
      nav: true,
      dots: false,
      animateOut: 'fadeOut',
      navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
      // navContainer: '#customNav',
      responsive: {
        0: {
          items: 1
        },
        700: {
          items: 2,
          margin: 0,
        },
        1200: {
          items: 3,
        }
      }
    });

    $('.owl-video-testimonials').each(function () {
      var $slider = $(this);

      if ($slider.hasClass('owl-loaded')) {
        return;
      }

      $slider.owlCarousel({
        margin: 40,
        loop: $slider.children().length > 4,
        nav: false,
        dots: true,
        autoplay: true,
        animateOut: 'fadeOut',
        responsive: {
          0: {
            items: 1.15,
            margin: 14
          },
          768: {
            items: 2.2,
            margin: 16
          },
          1200: {
            items: 4,
            margin: 18
          }
        }
      });
    });

    /*
     * Video modal 
     */
    $("body").on("click", "#play-video-modal", function (e) {
      e.preventDefault();
      $("#video-modal").modal("show");
      $("#video-modal iframe")[0].src += "?autoplay=1";
    });

	    $("#video-modal").on('hidden.bs.modal', function (e) {
	      var videoUrl = $("#video-modal iframe")[0].src;
	      videoUrl = videoUrl.replace("?autoplay=1", "");
	      $("#video-modal iframe")[0].src = videoUrl;
	    });

	    /*
	     * Vimeo testimonials modal
	     */
	    var closeVideoTestimonialsModal = function ($modal) {
	      if (!$modal.length) {
	        return;
	      }

	      $modal.removeClass('is-active');
	      $('body').removeClass('video-testimonials-modal-open');

	      window.setTimeout(function () {
	        $modal.attr('hidden', true).attr('aria-hidden', 'true');
	        $modal.find('.video-testimonials-modal__iframe').attr('src', '');
	      }, 200);
	    };

	    $('body').on('click', '.js-video-testimonial-trigger', function (e) {
	      e.preventDefault();

	      var $trigger = $(this);
	      var modalId = $trigger.data('modal-id');
	      var embedUrl = $trigger.data('embed-url');
	      var $modal = $('#' + modalId);
	      var autoplayUrl = embedUrl + (embedUrl.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&autopause=0';

	      if (!$modal.length || !embedUrl) {
	        return;
	      }

	      $modal.find('.video-testimonials-modal__iframe').attr('src', autoplayUrl);
	      $modal.removeAttr('hidden').attr('aria-hidden', 'false');
	      $('body').addClass('video-testimonials-modal-open');

	      window.requestAnimationFrame(function () {
	        $modal.addClass('is-active');
	      });
	    });

	    $('body').on('click', '.js-video-testimonial-close', function (e) {
	      e.preventDefault();
	      closeVideoTestimonialsModal($(this).closest('.video-testimonials-modal'));
	    });

	    $(document).on('keydown', function (e) {
	      if ('Escape' !== e.key) {
	        return;
	      }

	      closeVideoTestimonialsModal($('.video-testimonials-modal.is-active'));
	    });

	    /*
	     * Youtube lazy loading
	     */
    $('#play-video-btn').on('click', function (e) {
      e.preventDefault();
      $('#youtubeModal').modal('show');
    });

    $("#youtubeModal").on('hidden.bs.modal', function (e) {
      $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
    });

    /*
     * Single post table of contents
     */
    var $singlePostContent = $('#single-post .single-post-main');
    var $singlePostTocCard = $('#single-post .single-post-sidebar__card--toc');
    var $singlePostTocList = $('#single-post-toc-list');

    if ($singlePostContent.length && $singlePostTocCard.length && $singlePostTocList.length) {
      var usedIds = {};
      var tocItems = [];

      $singlePostContent.find('h2').each(function () {
        var $heading = $(this);
        var headingText = $.trim($heading.text());

        if (!headingText.length) {
          return;
        }

        var headingId = $heading.attr('id');

        if (!headingId) {
          headingId = headingText
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-');

          if (!headingId.length) {
            headingId = 'section';
          }
        }

        var uniqueId = headingId;
        var index = 2;

        while (usedIds[uniqueId] || document.getElementById(uniqueId)) {
          if ($heading.attr('id') === uniqueId) {
            break;
          }

          uniqueId = headingId + '-' + index;
          index++;
        }

        usedIds[uniqueId] = true;
        $heading.attr('id', uniqueId);

        tocItems.push({
          id: uniqueId,
          text: headingText
        });
      });

      if (tocItems.length) {
        $.each(tocItems, function (_, item) {
          $singlePostTocList.append(
            $('<li />', {
              'class': 'single-post-sidebar__toc-item'
            }).append(
              $('<a />', {
                href: '#' + item.id,
                text: item.text
              })
            )
          );
        });

        $singlePostTocCard.prop('hidden', false);
      }
    }



    /*
     * Scroll up button
     */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.scroll-to-top').addClass('show');
      } else {
        $('.scroll-to-top').removeClass('show');
        $('.scroll-to-top').addClass('animated bounceOutDown');
        $('.scroll-to-top').removeClass('animated bounceOutUp');
        $('.scroll-to-top i').css('transform', 'rotateY(0) scale(1)');
      }
    });

    $('.scroll-to-top').on("click", function () {
      $('.scroll-to-top').addClass('animated bounceOutUp');
      $('.scroll-to-top i').css('transform', 'rotateY(180deg) scale(1.2)');
      $("html, body").animate({
        scrollTop: 0
      }, 1000);
      return false;
    });

    /*
     * Lightbox gallery
     */
    $('.gallery-images').lightGallery({
      selector: '.gallery-item',
      share: true,
      download: true,
      rotate: false,
      showThumbByDefault: true,
      loop: false,
      slideEndAnimatoin: false,
      thumbnail: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      youtubePlayerParams: {
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        modestbranding: 1,
        showinfo: 0,
        rel: 0
      }
    });



    /*
     * Mmenu light 
     */
    var menu = new MmenuLight(
      document.querySelector('#my-menu'),
      'all'
    );
    if (menu) {
      var navigator = menu.navigation({
        // selectedClass: 'Selected',
        // slidingSubmenus: true,
        theme: 'light',
        title: 'Menü'
      });

      var drawer = menu.offcanvas({
        position: 'right'
      });

      //  Open the menu.
      document.querySelector('#nav-icon')
        .addEventListener('click', evnt => {
          evnt.preventDefault();
          drawer.open();
        });

      $(".mob-menu-close").click(function () {
        drawer.close();
      });
    }

  });
})(jQuery);
